import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getAppMetrics } from "../Actions/API/AppInstance/AppInstanceActions"
import { APIAppInstanceMetricModel } from "../Models/API/AppMetricModel"
import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"

export const useAppMeasurerMetrics = (
    appID: string
): FetchState<APIAppInstanceMetricModel[]> => {
    const dispatch = useDispatch()
    const metricsFetch = useAppState(state => state.api.apps.metrics[appID])

    useEffect(() => {
        if (metricsFetch === undefined) dispatch(getAppMetrics(appID))
    }, [appID, dispatch, metricsFetch])

    return metricsFetch
}
